/**
 * @description
 * 404 에러 페이지
 */
const Error404Page = () => {
  return <p>페이지를 찾을 수 없습니다.</p>;
};

export default Error404Page;
